// Module
var code = "<div class=\"block-6__images\"> <div class=\"block-6__image-small image\"></div> <div class=\"block-6__image image\"></div> </div> <div class=\"block-6__quote quote\"></div> ";
// Exports
export default code;